const jspdf = require('jspdf')
const moment = require('moment')
const _ = require('lodash')
const axios = require('axios')
const Constant = require('@/const')
import loadImage from 'async-image'

const IDR = value => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(value || 0)

export default async function createInvoice({ id_payment }) {
  const response = await axios.post(Constant.default.apiUrl.concat('/payment/', id_payment, '/invoice'))
  const inv = response.data.data

  let imageLogo = await loadImage(Constant.default.apiUrl.concat('/static/storage/assets/logotaawun.png'))

  const doc = new jspdf.jsPDF()

  const invoiceNumber = _.get(inv, 'invoice_number', '-')
  const invoiceDate = moment(_.get(inv, 'invoice_date'))
    .locale('id')
    .format('DD MMMM YYYY')
  const companyName = _.get(inv, 'company', '-')
  const branch = _.get(inv, 'branch', '-')
  const periodeMonth = _.get(inv, 'periode_month', '')
  const periodeYear = _.get(inv, 'periode_year', '')
  const subscriptionCount = _.get(inv, 'subscription_count', 0)
  const total = _.get(inv, 'total', 0)

  // --- Header ---
  doc.addImage(imageLogo, 'png', 10, 10, 70, 18)
  doc.setFontSize(16)
  doc.setFont(undefined, 'bold')
  doc.text('INVOICE PEMBAYARAN IURAN', 140, 18, { align: 'center' })
  doc.setFont(undefined, 'normal')
  doc.setFontSize(10)
  doc.text('PBMT Taawun', 140, 24, { align: 'center' })

  doc.setLineWidth(0.5)
  doc.line(10, 33, 200, 33)

  // --- Invoice info ---
  doc.setFontSize(11)

  const infoLabels = [
    { text: 'No. Invoice', value: invoiceNumber },
    { text: 'Tanggal Invoice', value: invoiceDate },
    { text: 'BMT', value: companyName },
    { text: 'Cabang', value: branch },
    { text: 'Periode', value: `${periodeMonth} ${periodeYear}`.trim() },
    { text: 'Jumlah Peserta', value: String(subscriptionCount) }
  ]

  let y = 42
  for (const label of infoLabels) {
    doc.text(label.text, 15, y)
    doc.text(':', 65, y)
    doc.text(label.value, 70, y)
    y += 8
  }

  // --- Total ---
  y += 4
  doc.setLineWidth(0.5)
  doc.line(10, y, 200, y)
  y += 8
  doc.setFontSize(13)
  doc.setFont(undefined, 'bold')
  doc.text('Total Pembayaran', 15, y)
  doc.text(':', 90, y)
  doc.text(IDR(total), 95, y)
  doc.setFont(undefined, 'normal')
  doc.setLineWidth(0.5)
  y += 4
  doc.line(10, y, 200, y)

  // --- Payment info ---
  y += 10
  doc.setFontSize(11)
  doc.setFont(undefined, 'bold')
  doc.text('Informasi Pembayaran:', 15, y)
  doc.setFont(undefined, 'normal')
  y += 7

  const paymentInfoLabels = [
    { text: 'Nama Bank', value: 'Bank Syariah Indonesia' },
    { text: 'Nama Rekening', value: 'PBMT Taawun' },
    { text: 'Nomor Rekening', value: '4375936400' }
  ]
  for (const label of paymentInfoLabels) {
    doc.text(label.text, 15, y)
    doc.text(':', 55, y)
    doc.text(label.value, 60, y)
    y += 7
  }

  // --- Payment deadline note ---
  y += 4
  const today = moment()
  const deadline = moment().date(15)
  if (today.date() >= 15) {
    deadline.add(1, 'month')
  }
  const deadlineDate = deadline.locale('id').format('DD MMMM YYYY')

  doc.setFontSize(10)
  doc.text(`Pembayaran paling lambat dilakukan sebelum tanggal ${deadlineDate}.`, 15, y)
  y += 6
  doc.text('Mohon untuk segera dilakukan pembayaran dan upload bukti transfer pada sistem,', 15, y)
  y += 6
  doc.text('terimakasih.', 15, y)

  // --- Footer ---
  y += 25
  doc.setFontSize(10)
  doc.text(
    `Yogyakarta, ${moment()
      .locale('id')
      .format('DD MMMM YYYY')}`,
    120,
    y
  )
  doc.text('PBMT Taawun', 138, y + 8)
  y += 18
  doc.addImage(imageLogo, 'png', 120, y, 50, 13)
  y += 18
  doc.text('Admin Keuangan', 133, y)

  const fileCompany = companyName
    .toLowerCase()
    .split(' ')
    .join('_')
  const filePeriode = `${periodeMonth}_${periodeYear}`
    .toLowerCase()
    .split(' ')
    .join('_')
  doc.save(`invoice_${fileCompany}_${filePeriode}.pdf`)
}
